import type { EpocusRequestPriority } from "$global-providers/rxdb-provider/collections/epocus-encounter";
import type { ExamType } from "$global-providers/rxdb-provider/collections/epocus-exam-worksheets";
import { EXAM_LABELS } from "../epocus-exam-constants";

export const DEFAULT_REQUEST_PRIORITY: EpocusRequestPriority = "routine";

export const REQUEST_PRIORITY_OPTIONS: readonly {
  value: EpocusRequestPriority;
  label: string;
}[] = [
  { value: "routine", label: "Routine" },
  { value: "urgent", label: "Urgent" },
];

export const requestPriorityLabel = (
  priority: EpocusRequestPriority | null,
): string => (priority === "urgent" ? "Urgent" : "Routine");

export const requestedExamTypeLabel = (
  requestedExamType: string | null,
): string | null => {
  if (!requestedExamType) return null;

  return EXAM_LABELS[requestedExamType as ExamType] ?? requestedExamType;
};

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const relativeRequestAge = (
  requestedAt: string | null,
  now: number = Date.now(),
): string | null => {
  if (!requestedAt) return null;

  const requested = new Date(requestedAt).getTime();
  if (Number.isNaN(requested)) return null;

  const elapsed = Math.max(0, now - requested);
  if (elapsed < MINUTE) return "just now";
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)}m ago`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)}h ago`;

  return `${Math.floor(elapsed / DAY)}d ago`;
};
